import { useQuery } from "@tanstack/react-query"
import api from "../utils/api"

const fetchGame = (gamePk) => {
    return api.get(`/v1.1/game/${gamePk}/feed/live`);
}

export const useGameData = (gamePk) => {
    return useQuery(['game', gamePk], () => fetchGame(gamePk), {
        select: (d) => ({ data: d }), // preserves data.data.* shape used by consumers
        suspense: true,
        // 15s Background Polling; stop once the game is Final (data never changes)
        refetchInterval: (data) =>
            data?.data?.gameData?.status?.abstractGameState === 'Final' ? false : 15000
    });
}